export default __webpack_public_path__ + "images/pg-dcb8c4ab032af81620bdf25bc2ff9575.svg";